import {
  Button,
  Card,
  Modal,
  Stack,
  TextField,
  Typography,
  Avatar,
  IconButton,
  CardMedia,
  Grid,
  Box,
  useTheme,
  useMediaQuery,
  ListItemText
} from "@mui/material";
import { BIBlue, BIYellow } from "../../assets/helpers";
import { ArrowDownwardRounded, ArrowUpwardRounded } from "@mui/icons-material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import RoomIcon from "@mui/icons-material/Room";
import AddIcon from "@mui/icons-material/Add";
import { Close as CloseIcon } from "@mui/icons-material";
import { Save as SaveIcon, Refresh as RefreshIcon, Crop } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";

const MontageTutorial = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Montages || {};
  const {
    TEXT_APP_HEADER = English.Montages.TEXT_APP_HEADER,
    TEXT_TUTORIAL_DESCRIPTION = English.Montages.TEXT_TUTORIAL_DESCRIPTION,
    TEXT_TUTORIAL_TAP_TO_CONTINUE = English.Montages.TEXT_TUTORIAL_TAP_TO_CONTINUE,
    TEXT_TUTORIAL_VIDEO = English.Montages.TEXT_TUTORIAL_VIDEO,
    TEXT_TUTORIAL_ADD_PHOTO_1 = English.Montages.TEXT_TUTORIAL_ADD_PHOTO_1,
    TEXT_TUTORIAL_ADD_PHOTO_2 = English.Montages.TEXT_TUTORIAL_ADD_PHOTO_2,
    TEXT_TUTORIAL_ADD_PHOTO_3 = English.Montages.TEXT_TUTORIAL_ADD_PHOTO_3,
    TEXT_ADD_BLANK_PAGE = English.Montages.TEXT_ADD_BLANK_PAGE,
    TEXT_PHOTOS_FROM_PROJECT = English.Montages.TEXT_PHOTOS_FROM_PROJECT,
    TEXT_ADD_FROM_COMPUTER = English.Montages.TEXT_ADD_FROM_COMPUTER,
    BUTTON_ADD_SOUND = English.Montages.BUTTON_ADD_SOUND,
    TEXT_TUTORIAL_MAIN_SCREEN = English.Montages.TEXT_TUTORIAL_MAIN_SCREEN,
    TEXT_TUTORIAL_MAIN_SCREEN_SUB = English.Montages.TEXT_TUTORIAL_MAIN_SCREEN_SUB,
    TEXT_TUTORIAL_EDITOR = English.Montages.TEXT_TUTORIAL_EDITOR,
    TEXT_TUTORIAL_EDITOR_SUB = English.Montages.TEXT_TUTORIAL_EDITOR_SUB,
    TEXT_TUTORIAL_SAVE = English.Montages.TEXT_TUTORIAL_SAVE,
    TEXT_ADD_ON_TEXT = English.Montages.TEXT_ADD_ON_TEXT,
    TEXT_BACK_BUTTON = English.Montages.TEXT_BACK_BUTTON,
    TEXT_TITLE = English.Montages.TEXT_TITLE
  } = LanguageData || {};

  const cardOptions = [
    {
      icon: <SummarizeIcon />,
      text: TEXT_ADD_BLANK_PAGE,
      avatarSx: {
        backgroundColor: "white",
        border: "3px solid grey",
        color: "black",
        cursor: "pointer"
      }
    },
    {
      icon: <RoomIcon />,
      text: TEXT_PHOTOS_FROM_PROJECT,
      avatarSx: {
        backgroundColor: "white",
        border: "3px solid red",
        color: "black",
        cursor: "pointer"
      }
    },
    {
      icon: <Typography variant="subtitle1"> {`${0}/5`} </Typography>,
      text: TEXT_ADD_FROM_COMPUTER,
      avatarSx: {
        backgroundColor: "white",
        border: "3px solid yellow",
        color: "black",
        cursor: "pointer"
      }
    }
  ];

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 240;

  return (
    <Modal open={props?.tutorialIndex === 0 ? false : true}>
      <Box sx={{ backgroundColor: "rgba(0, 0, 0, 0.7)", height: "100%" }} onClick={props.onPress}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
            overflowY: "auto",
            mt: `${theme.mixins.toolbar.minHeight}px`,
            width: { sm: props.tutorialIndex === 1 ? "100%" : `calc(100% - ${drawerWidth}px)` },
            marginLeft: { sm: props.tutorialIndex === 1 ? 0 : `${drawerWidth}px`, xs: 0 }
          }}>
          <Box
            className="main-content-Box"
            sx={{ p: isSmallScreen ? 2 : 3, backgroundColor: "transparent" }}>
            {props.tutorialIndex === 1 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh"
                }}>
                <Stack sx={{ textAlign: "center", color: "white" }}>
                  <Typography variant="h6">{TEXT_APP_HEADER}</Typography>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_DESCRIPTION}</Typography>
                  <Typography variant="body1">
                    <span style={{ color: BIBlue }}> {`(${TEXT_TUTORIAL_TAP_TO_CONTINUE})`}</span>
                  </Typography>
                </Stack>
              </Box>
            )}
            {props.tutorialIndex === 2 && (
              <Card
                className="main-content-card"
                sx={{
                  mt: 0,
                  p: 0,
                  backgroundColor: "transparent !important",
                  border: "none",
                  justifyContent: "flex-end"
                }}>
                <Stack sx={{ display: "flex", alignItems: "center" }} textAlign={"center"} m={0.5}>
                  <Typography sx={{ color: "white" }}> {TEXT_TUTORIAL_VIDEO}</Typography>
                  <IconButton>
                    <ArrowDownwardRounded style={{ fontSize: "30px", color: "white" }} />
                  </IconButton>
                </Stack>
                <Box sx={{ justifyContent: "center",  display: "flex", backgroundColor: "white", p: 2, pt: 3 }}>
                  <Box sx={{ mt: 0.5 }}></Box>
                  <Box>
                    <Button
                      fullWidth
                      variant="outlined"
                      sx={{
                        width: { xs: 100, md: 175 },
                        height: { xs: 85, md: 95 },
                        borderStyle: "solid",
                        color: BIBlue
                      }}>
                      <AddIcon fontSize="small" />
                    </Button>
                  </Box>
                </Box>
              </Card>
            )}

            {props.tutorialIndex === 3 && (
              <Box
                className="user-modal-responsive"
                sx={{ boxShadow: "none", backgroundColor: "transparent" }}>
                <Stack
                  sx={{
                    display: "flex",
                    textAlign: "center",
                    alignItems: "center",
                    color: "white"
                  }}>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_ADD_PHOTO_1}</Typography>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_ADD_PHOTO_2}</Typography>
                  <Typography variant="subtitle1">{TEXT_TUTORIAL_ADD_PHOTO_3}</Typography>
                  <Typography variant="body1">
                    <ArrowDownwardRounded />
                  </Typography>
                </Stack>
                <Box sx={{ backgroundColor: "white", padding: "15px", borderRadius: "10px" }}>
                  <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
                    {cardOptions.map((option, index) => (
                      <Grid key={index} size={{ xs: 12, sm: 4 }} sx={{ justifyContent: "center" }}>
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1
                          }}>
                          <Avatar sx={option.avatarSx}>{option.icon}</Avatar>
                          <Typography variant="subtitle1">{option.text}</Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            )}

            {props.tutorialIndex === 4 && (
              <>
                <Box className="main-content-Box" sx={{ p: 0 }}>
                  <Stack sx={{ display: "flex", alignItems: "center" }} textAlign={"center"} m={0.5}>
                    <Typography sx={{ color: "white" }}>
                      {" "}
                      {TEXT_TUTORIAL_MAIN_SCREEN} {TEXT_TUTORIAL_MAIN_SCREEN_SUB}
                    </Typography>
                    <IconButton>
                      <ArrowDownwardRounded style={{ fontSize: "30px", color: "white" }} />
                    </IconButton>
                  </Stack>
                  <Card className="main-content-card" sx={{ mt: { xs: 3, sm: 3.5, md: 0.8 } }}>
                    <Box className="main-content-Box">
                      <Card
                        className="main-content-card"
                        sx={{
                          p: 0,
                          mt: 0,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}>
                        <IconButton disabled size="large">
                          <PlayCircleFilledIcon fontSize="large" />
                        </IconButton>
                      </Card>
                    </Box>
                  </Card>
                </Box>
                <Box sx={{ justifyContent: "center",  display: "flex", p: 2 }}>
                  <Box sx={{ ml: 1.5 }}></Box>
                  <Box>
                    <Button
                      fullWidth
                      disabled
                      variant="outlined"
                      sx={{
                        width: { xs: 100, md: 175 },
                        height: { xs: 85, md: 95 },
                        borderStyle: "solid",
                        color: BIBlue
                      }}>
                      <AddIcon fontSize="small" />
                    </Button>
                  </Box>
                </Box>
              </>
            )}

            {props.tutorialIndex === 5 && (
              <Card
                className="main-content-card"
                sx={{
                  mt: 0,
                  p: 0,
                  backgroundColor: "transparent !important",
                  border: "none",
                  justifyContent: "flex-end"
                }}>
                <Stack sx={{ display: "flex", alignItems: "center" }} textAlign={"center"} m={0.5}>
                  <Typography sx={{ color: "white" }}>
                    {" "}
                    {TEXT_TUTORIAL_EDITOR} {TEXT_TUTORIAL_EDITOR_SUB}
                  </Typography>
                  <IconButton>
                    <ArrowDownwardRounded style={{ fontSize: "30px", color: "white" }} />
                  </IconButton>
                </Stack>
                <Box sx={{ justifyContent: "space-between",  display: "flex", backgroundColor: "white", p: 2 }}>
                  <Box sx={{ mt: 0.5 }}>
                    <Card
                      className="main-div"
                      sx={{
                        width: { xs: 100, md: 175 },
                        height: { xs: 85, md: 95 }
                      }}
                      style={{
                        position: "relative",
                        border: `2px solid ${BIYellow}`
                      }}>
                      <span
                        style={{
                          position: "absolute",
                          cursor: "pointer",
                          height: "10px"
                        }}>
                        <IconButton>
                          <CloseIcon />
                        </IconButton>
                      </span>
                      <CardMedia
                        component="img"
                        image="https://biappstoragetest2.blob.core.windows.net/userprofiles/3/20230728062624980img.jpg"
                        alt="seleted image show"
                        style={{
                          objectFit: "cover",
                          height: "100%",
                          width: "100%"
                        }}
                      />
                      <Box className="card-desc-div">
                        <TextField
                          className="card-descriptions"
                          placeholder={TEXT_ADD_ON_TEXT}
                          type="text"
                          variant="standard"
                          value={""}
                          sx={{
                            input: {
                              color: "white",
                              pl: 1,
                              pr: 1
                            }
                          }}
                        />
                      </Box>
                    </Card>
                  </Box>
                  <Box>
                    <Button
                      fullWidth
                      variant="outlined"
                      sx={{
                        width: { xs: 100, md: 175 },
                        height: { xs: 85, md: 95 },
                        borderStyle: "solid",
                        color: BIBlue
                      }}>
                      <AddIcon fontSize="small" />
                    </Button>
                  </Box>
                </Box>
              </Card>
            )}

            {props.tutorialIndex === 6 && (
              <>
                <Box className="main-content-Box" sx={{ p: 0, mt: { xs: 3.7, sm: 3, md: 4 } }}>
                  <Grid
                    container
                    gap={{ xs: 0 }}
                    sx={{
                      alignItems: "center",
                      p: 2,
                      pb: 1.5,
                      borderRadius: "3px",
                      backgroundColor: "white"
                    }}>
                    <Grid size={{ xs: 8, sm: 8, md: 8, lg: 4, xl: 4 }}>
                      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "row", gap: 1 }}>
                        <Button variant="contained" sx={{ width: "50%" }}>
                          {TEXT_BACK_BUTTON}
                        </Button>
                        <TextField
                          type="text"
                          label={TEXT_TITLE}
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      </Box>
                    </Grid>
                    <Grid
                      sx={{ display: { xs: "none", lg: "flex"  }}}
                      size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}>
                      <ListItemText
                        style={{
                          color: "var(--buildid-blue)",
                          cursor: "pointer",
                          textAlign: "center" // Ensures text inside is centered
                        }}>
                        {BUTTON_ADD_SOUND}
                      </ListItemText>
                    </Grid>
                    <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}>
                      <Stack direction="row"  sx={{ gap: 1, justifyContent: "flex-end", display: "flex" }} >
                        <IconButton
                          sx={{ p: isSmallScreen ? 0 : 1 }}
                          color="primary"
                          aria-label="Replay"
                          size="medium">
                          <RefreshIcon fontSize={isSmallScreen ? "small" : "medium"} />
                        </IconButton>
                        <IconButton
                          sx={{ p: isSmallScreen ? 0 : 1 }}
                          aria-label="Crop"
                          color="primary"
                          size="medium">
                          <Crop fontSize={isSmallScreen ? "small" : "medium"} />
                        </IconButton>
                        <IconButton
                          sx={{ p: isSmallScreen ? 0 : 1 }}
                          aria-label="Save"
                          color="primary"
                          size="medium">
                          <SaveIcon fontSize={isSmallScreen ? "small" : "medium"} />
                        </IconButton>
                      </Stack>
                    </Grid>
                    <Grid
                      sx={{ display: { xs: "flex", lg: "none"  }}}
                      size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}></Grid>
                  </Grid>

                  <Stack sx={{ display: "flex", alignItems: "flex-end" }} textAlign={"center"} m={0.5}>
                    <IconButton sx={{ mr: 3 }}>
                      <ArrowUpwardRounded style={{ fontSize: "30px", color: "white" }} />
                    </IconButton>
                    <Typography sx={{ color: "white" }}>{TEXT_TUTORIAL_SAVE}</Typography>
                  </Stack>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default MontageTutorial;
